import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgSelectModule } from "@ng-select/ng-select";
import { BackendService } from '../../core/services/backend.service';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';
import { CustomDatePipe } from '../../core/pipes/date.pipe';
import { MenuBarComponent } from '../../core/components/menu-bar/menu-bar.component';
import { FooterComponent } from '../../core/components/footer/footer.component';
import { AdminNavComponent } from '../../core/components/admin-nav/admin-nav.component';
import { NgxTgModule } from '@worthy-ventures/metaglotta-ngx';
import { forkJoin, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  imports: [NgSelectModule, FormsModule, MatTableModule, CommonModule, CustomDatePipe, MenuBarComponent, FooterComponent, AdminNavComponent, NgxTgModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  isMenuOpen = false;
  selectedLang = 'EN';
  orders: any[] = [];
  displayedColumns = ['id', 'clientName', 'date', 'amount', 'status', 'assignedTo', 'actions'];
  dashboardStats: any = {};

  /**
   * Covers the cards and the latest-orders table until both requests land.
   * The cards fall back to 0 for anything missing, so drawn early they read as
   * a real "0€ revenue, 0 orders" rather than as still loading.
   */
  loading = true;

  constructor(private router: Router, private backendService: BackendService) { }

  ngOnInit() {
    // Joined so the page fills in once rather than in two pops. Each side
    // still degrades on its own, as before: handleError has already toasted,
    // and a failed request leaves its half at its defaults instead of failing
    // the join and blanking the other.
    forkJoin({
      orders: this.backendService.getOrders(true).pipe(catchError(() => of(null))),
      stats: this.backendService.calculateDashboardStats().pipe(catchError(() => of(null))),
    })
      .pipe(finalize(() => { this.loading = false; }))
      .subscribe(({ orders, stats }) => {
        this.orders = orders?.data?.orders ?? [];
        this.dashboardStats = stats?.data?.stats ?? {};
      });
  }

  public viewOrder(order: any) {
    this.router.navigate([`dashboard/orders/${order.id}`]);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  /**
   * Count for a status over the last 31 days, from the stats endpoint.
   *
   * Not derived from `orders`: that list is the latest 10 for the table below,
   * so counting it would under-report as soon as there are more than ten.
   */
  statusCount(status: string): number {
    return this.dashboardStats?.statusCounts?.[status] ?? 0;
  }
}